import axios from '../utils/axios';

export default function postProfileImgFromLink(adminId, data) {
    return axios.post(`/admin/${adminId}/upload-image-from-link`, data);
};
